import Router from 'next/router'
import { type AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { proxyRequestMerchants, resetProxyRequestMerchant } from '../proxyRequestMerchants'
import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'
import { proxyGlobalAuth } from '../../../../shared/proxies/proxyGlobalAuth'
import { GlobalSiteDomainEnum } from '../../../../shared/types/GlobalSiteDomainEnum'

interface Args {
  email: string
}

interface Response {
  data: any
  error: string | null
}

export async function executeRequestMerchants ({ email }: Args): Promise<void> {
  proxyRequestMerchants.apiCallRequestMerchant.loading = true
  proxyRequestMerchants.apiCallRequestMerchant.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/auth/request_merchants', {
      email: email.toLowerCase(),
      uiDomain: proxyGlobalAuth.siteDomainEnum ?? GlobalSiteDomainEnum.StandardPay
    })
    if (!response.data.error) {
      void Router.push('/auth/login')
      resetProxyRequestMerchant()
      toast.success('If we find an account matching the details provided, an email will be sent with further instructions')
    } else {
      proxyRequestMerchants.apiCallRequestMerchant.error = 'Unknown Error'
    }
  } catch (e) {
    if (e instanceof Error) {
      const bodyError = (e as AxiosError<Response>).response?.data?.error
      proxyRequestMerchants.apiCallRequestMerchant.error = bodyError ?? e.message
    }
  } finally {
    proxyRequestMerchants.apiCallRequestMerchant.loading = false
  }
}
